import {
  Box,
  Button,
  Card,
  Container,
  CssBaseline,
  Dialog,
  FormControl,
  Grid,
  Link,
  ThemeProvider,
  Typography,
  useTheme,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  TextField,
} from "@mui/material";
import api from "../../../redux/features/auth/axiosAuthHelper";
import { Field, FormikProvider, useFormik } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import assets from "../../../assets";
import { FormEmailTextField } from "../fields/AuthFields";
import colorConfigs from "../../../configs/colorConfigs";
import versionConfig from "../../../configs/versionConfig";
import RareButton from "../buttons/RareButton";

function Copyright(props: any) {

  return (
    <Typography data-testid="Typography-9j8n"
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      NovarumDX is registered trademarks of NovarumDX in many countries of the world.
    </Typography>
  );
}

export default function ForgottenPasswordCard() {
  const [showDialog, setShowDialog] = useState(false);

  const navigate = useNavigate();
  const theme = useTheme();

  const validationSchema = () => {
    return Yup.object().shape({
      email: Yup.string()
        .email("Invalid email format")
        .required("This field is required"),
    });
  };

  const handleClose = () => {
    setShowDialog(false);
    navigate("/login");
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const post_data = {
        email: values.email,
      };
      console.log(post_data);
      api
        .post("auth/password-reset/", post_data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
      setShowDialog(true);
    },
  });

  return (
    <Box data-testid="Box-2l7g"
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        px: 2,
        minWidth: '60vw',
      }}
    >
      {/* Logo at the top */}
      <Box data-testid="Box-cn93"
        component="img"
        sx={{
          width: { xs: '53%', sm: '53%', md: '53%' }, // Responsive widths
          height: 'auto',
          my: 2,
        }}
        alt="Premier Biotech OT Scan Logo"
        src={assets.images.pbiologoexpand}
      />

      {/* Sign‑in card */}
      <Card data-testid="Card-r1ui"
        sx={{
          width: '60%',
          boxShadow: 10,
          p: { xs: 3, sm: 4, md: 5, lg: 8 },
          borderRadius: 5,
        }}
      >
        <CssBaseline />
        {showDialog && (
          <Dialog data-testid="Dialog-044r"
            open={showDialog}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle data-testid="DialogTitle-gyox" id="alert-dialog-title">
              Password Recovery
            </DialogTitle>
            <DialogContent data-testid="DialogContent-eq5i">
              <DialogContentText id="alert-dialog-description">
                {"We have sent an email to "}{" "}
                <strong>{formik.values.email}</strong>
                {" with instructions to reset your password. "}
              </DialogContentText>
            </DialogContent>
            <DialogActions data-testid="DialogActions-a0uh">
              <Button data-testid="Button-vsr0" onClick={handleClose} color="primary" autoFocus>
                {"Return to Login"}
              </Button>
            </DialogActions>
          </Dialog>
        )}

        <Box data-testid="Box-745d"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box data-testid="Box-7iot" sx={{ width: '100%', }} />
          <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit} style={{ width: '100%', }}>
              <Box data-testid="Box-5qv3" sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                <Field data-testid="Field-cgqq"
                  name="email"
                  type="text"
                  className="form-control"
                  label="Email"
                  autoFocus
                  component={FormEmailTextField}
                />
              </Box>

              <Box data-testid="Box-u5a7"
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  my: 2,
                }}
              >
                <RareButton data-testid="RareButton-x2e1"
                  type="submit"
                  fullWidth
                  variant="contained"
                  disabled={!formik.values.email}
                  sx={{ width: { xs: '90%', sm: '50%' } }} >
                  Submit
                </RareButton>
              </Box>

            </form>
          </FormikProvider>
        </Box>
        <Box data-testid="Box-zb6f" sx={{ alignSelf: 'flex-start' }} >
          <Link data-testid="Link-26qc" href="/login" variant="body2">
            Return to  Login
          </Link>
        </Box>
        <Typography data-testid="Typography-vjno" variant="body2" color="text.secondary" align="center">
          {versionConfig.version}
        </Typography>
      </Card>
    </Box>
  );
}
